import { api, type AppearanceRow, type PageNew } from '@setplex/tria-api'
import { createEffect } from 'effector'
import { logger } from '~/shared/logger'
import { APPEARANCE_DEFAULT_HOME_ROWS } from './defaults'
import type { TGetRowsFx } from '~/widgets/DynamicModule/model/rows'
import { filterRowsVisibility } from '~/widgets/DynamicModule'

export const getHomeRowsFx = createEffect(
  async ({ source, params }: TGetRowsFx) => {
    let rows: PageNew<AppearanceRow>

    const grab = {
      enabled: async () => api.appearance.getModuleRowsFx(params),

      // enabled: async () => dynamicModule.getRowsFx(params),
      disabled: async () => APPEARANCE_DEFAULT_HOME_ROWS(),
      fallback: async () => APPEARANCE_DEFAULT_HOME_ROWS(true),
    }

    // if `appearanceCustomizationEnabled` is not defined - this is old wbs, use fallback
    if (source.features.appearanceCustomizationEnabled == null) {
      rows = await grab.fallback()
    }

    // if `appearanceCustomizationEnabled` is enabled - load rows from the server
    else if (source.features.appearanceCustomizationEnabled) {
      try {
        rows = await grab.enabled()
        // rows from dynamicModules already filtered
        // return rows
      } catch (error) {
        logger.error('Failed to load home rows:', error)

        // if this is the very first request - try to use default rows configuration as a fallback
        if (params == null || params.page === 0) {
          rows = await grab.disabled()
        } else {
          throw error
        }
      }
    }

    // if `appearanceCustomizationEnabled` is disabled - use default rows configuration
    else {
      rows = await grab.disabled()
    }

    rows.content = filterRowsVisibility(rows, source)

    return rows
  }
)
